__turbopack_context__.v({
  "disabled": "index-module__6BTTRW__disabled",
  "headerListItem": "index-module__6BTTRW__headerListItem",
  "heading": "index-module__6BTTRW__heading",
  "iconWrapper": "index-module__6BTTRW__iconWrapper",
  "perYear": "index-module__6BTTRW__perYear",
  "planTitle": "index-module__6BTTRW__planTitle",
  "price": "index-module__6BTTRW__price",
  "priceRow": "index-module__6BTTRW__priceRow",
  "root": "index-module__6BTTRW__root",
  "subtitle": "index-module__6BTTRW__subtitle",
  "tableWrapper": "index-module__6BTTRW__tableWrapper",
});
